"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M5 16h3.04l-1.52-2.03z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m9.78 11.63 1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6zM5 16l1.52-2.03L8.04 16z"
}, "1")], 'FilterHdrTwoTone');